<template lang="">
  <div class="message-form" style="height: 110vh">
    <Header
      title="Duplicar Disparos de SMS"
      subtitle="Área voltada para o envio de SMS"
      :has-separator="false"
    ></Header>

      <!-- Canal de envio -->
    <ValidationObserver v-slot="{ invalid }">
    <div class="d-flex responvive-short-card">
      <div> 
        <!-- Formulario -->
        <v-card class="pa-8 mb-12" height="538" width="826">
          <div class="d-flex flex-column">
            <span class="font-weight-black" for="name">
              Nome
            </span>
             <ValidationProvider
              rules="required"
              v-slot="{ errors }"
            >
            <input class="input-field pl-2 mt-3" placeholder="Nome da campanha" v-model="item.name"/>
              <span class="input-error">
                {{ errors[0] }} 
              </span>
            </ValidationProvider>
            <span class="font-weight-black mt-7" for="name">
              Título
            </span>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
            >
            <input class="input-field pl-2 mt-3" placeholder="Empiricus" v-model="item.title"/>
              <span class="input-error">
                {{ errors[0] }} 
              </span>
            </ValidationProvider>
            <span class="font-weight-black mt-7">
              Mensagem <span class="textAreaLength">{{textAreaLength}} / 127</span>
            </span>
            <textarea
              outlined
              rows="10"
              maxlength="127"
              class="text-area-field mt-3 pa-2"
              v-model="item.message"
            ></textarea>
          </div>
        </v-card>

        <!-- Informações adicionais -->
        <h4 class="mb-5">Informações Adicionais da Mensagem</h4>
        <v-card class="pa-8 mb-12" width="826" height="754">
          <div class="format-url pa-6">
            <p>Url</p>
            <div class="d-flex flex-row align-center">
              <input class="input-format-url pl-2 mr-2" placeholder="Url" v-model="item.url"/>
              <v-btn width="258" height="48" color="var(--red)" dark class="d-flex align-center sizeBtn">
                <img src="../../../../static/images/mic.svg">
                Formatar Url para Podcast
              </v-btn>
            </div>
          </div>
          
          <div class="mt-3 d-flex align-center">
            <img src="../../../../static/images/warning.svg"/>
            <label class="ml-4 mt-1">Utilizar esse campo em mensagens SMS pode quebrar o link em duas mensagens e o link acabar invalidado.</label>
          </div>

          <div class="d-flex flex-column">
            <span class="font-weight-black mt-5">
              Tipo
            </span>
            <v-select
              v-model="type"
              placeholder="Simples (sem link)"
              class="input-field mt-3"
              :options="listTypes"
              style="padding-top: 7px"
            />
            <span class="font-weight-black mt-5">
              Listas
            </span>
            <div class="text-area-field">
                <select v-if="list.length > 0" v-model="group" multiple style="width: 758px; height: 100%"
                >
                  <option v-for="(com, index) in lists"
                  :key="index"
                  class="pa-2">{{com.text}}</option>
                </select>
                <select v-else multiple style="width: 758px; height: 100%"
                >
                  <option class="pa-2">Sem listas disponíveis</option>
                </select>
            </div>
          </div>

          <div class="d-flex flex-row align-center mt-5">
            <span class="font-weight-black mb-0 mr-5">
              Tipo do Push
            </span>
            <v-switch
              v-model="item.pushType"
              color="var(--blue)"
              inset
            ></v-switch>
            <span> feed</span>
          </div>
          <span class="font-weight-black mt-5">
            Slug  do produto
          </span>
          <v-select
            v-model="item.produtoSlug"
            placeholder="Simples (sem link)"
            class="input-field mt-3"
            :options="listsProdutoSlug"
            style="padding-top: 7px"
          />
        </v-card>
      </div>

      <!-- Coluna 2 - Area de testes -->
      <div class="responvive-card">
        <!-- Area de teste -->
        <div class="calendar-card mr-6">
          <v-card class="px-8 py-8 schedule-teste">
            <h4>Área de testes</h4>
            <p class="mt-1">Antes de disparar os SMS faça o teste com o seu smartphone</p>

            <p class="font-weight-black mt-9" style="fontSize: 14px;">Visualização (sem acentuação para SMS)</p>
            <textarea
              placeholder="Empiricus"
              outlined
              rows="10"
              maxlength="127"
              class="text-area-field test-area mt-2 px-2 py-2">
            </textarea>
            <v-btn disabled width="308" height="56" color="var(--red)" class="mt-7">
              Enviar Teste por SMS <img class="ml-5" src="../../../../static/images/send_grey.svg"/>
            </v-btn>
          </v-card>
        </div>

        <!-- Agendamento -->
        <div class="calendar-card" style="marginTop: 92px">
          <v-card class="px-8 py-8 schedule-card">
            <h4>Agendamento</h4>
            <p class="mt-1">Escolha data e hora para que o envio do SMS</p>
            <v-card class="mt-11 d-flex flex-column" width="290">
              <v-date-picker
                v-model="picker"
                locale="pt-Br"
                :hide-header="false"
                no-title
                :min="nowDate"
              ></v-date-picker>
              <span class="rounded ma-3 d-flex align-center justify-flex-start" style="border: 2px solid var(--grey-day-030); height: 48px;">
                <img class="ma-3 " src="../../../../static/images/calendar.svg"/>{{ picker === '' ? formatDate(item.dateAdded) : formatDate(picker)}}
              </span>
              <div class="d-flex align-center justify-space-around ml-7" style="width: 220px">
                <v-row height="56" class="mt-5">
                  <span class="pt-5 font-weight-black mr-4">Horário</span>
                  <v-text-field
                    height="58"
                    width="100"
                    solo
                    value="00:00"
                    type="time"
                    v-model="pickerHour"
                  ></v-text-field>
                </v-row>
              </div>
            </v-card>
          </v-card>
        </div>
      </div>
    </div>

    <!-- Card enviar -->
    <v-card class="d-flex flex-row mt-8 justify-space-between align-center pa-7 mb-8 responsive-send-card" height="72px" color="var(--grey-day-070">
      <span class="white--text">Este disparo estará disponível dentro de Agendamentos. Se necessário poderá ser alterado ou cancelado.</span>
      <v-btn @click="duplicateSMS" height="48" width="220" class="px-3 py-3">
        <img src="../../../../static/images/save.svg"/>
        <span class="pl-3 py-3" style="fontFamily: var(--dm-sans-regular);">Enviar mensagem</span>
      </v-btn>
    </v-card>
    </ValidationObserver>

    <div style="height: 01px"></div>
  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'

// Libs
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapActions, mapState, mapMutations } from 'vuex'
import moment from 'moment'
// import DatePicker from 'vue2-datepicker'
// import 'vue2-datepicker/index.css'
// import 'vue2-datepicker/locale/pt-br'

//mixins
import date from '../../../mixins/date'

import VueCookies from 'vue-cookies'

export default {
  components: {
    Header,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [date],
  data () {
    return {
      channel: '',
      row: null,
      listsProdutoSlug: ['empiricus-crypto-alert', 'exponential-coins'],
      picker: '',
      type: '',
      listTypes: [
        'Simples (sem link)',
        'Link para conteúdo interno',
        'Link para conteúdo externo'
      ],
      errorMessage: '',
      openError: false,
      timeout: 3000,
      pickerHour: '',
      nowDate: new Date().toISOString().slice(0,10),
      group: []
    }
  },
  async created () {
    window.scrollTo(0, 0)
    this.pickerHour = moment(this.item.dateAdded).format('HH:mm')
    await this.fecthGroups()
  },
  computed: {
    ...mapState("Logs", {
      item: "logsToEdit",
    }),
    ...mapState("MessageForm", {
      list: "list",
    }),
    textAreaLength () {
      return this.item.message.length
    },
    momentDfat (data) {
      return moment(data, 'DD/MM/YYYY').format()
    },
    lists () {
      return this.list.map(l =>({
        text: l.group_name
      }))
    },
  },
  methods: {
    ...mapActions('MessageForm', {
      groups: 'groups',
    }),
    ...mapActions('Logs', {
      postLogs: 'postLogs'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    async fecthGroups () {
      const token = VueCookies.get('jwt-login')
      await this.groups(token)
    },
    async duplicateSMS () {
      const token = VueCookies.get('jwt-login')
      let pic = moment(this.picker).format('YYYY-MM-DD')
      if (this.picker === '' || this.pickerHour === '') {
        this.toaster(
          'Horário ou data vazio',
          'red',
          true
        )
      }
      if (this.picker === '') {
        this.toaster('Escolha uma data', 'red', true)
        return
      } else {
        const setTimer = `${pic} ${this.pickerHour}:00-0300`
        var date = new Date()
        try {
          const response = await this.postLogs([
            {
              messageChannel: this.item.channelType,
              groupIds: [this.item.list],
              message: this.item.message,
              messageType: this.item.messageType,
              nameCampaign: `${this.item.name} - ${Math.round(new Date(date.getTime() + ((-1) * date.getTimezoneOffset() * 60000)).getTime() / 1000)}`,
              name: this.item.name,
              pushType: this.item.pushType,
              smsMessage: this.item.smsContent,
              title: this.item.title,
              url: this.item.url,
              sendTime: setTimer
            },
            token
          ])
        if (response.status >= 400) {
            // throw new Error(response.data.message)
            this.openError = true
            this.errorMessage = response.data.message
            this.toaster(
              'Falha no envio da mensagem',
              'red',
              true
            )
            return
          } else {
            this.toaster(
              'SMS duplicado com sucesso',
              'green',
              true
            )
          }
          this.$router.push({ path: '/scheduling-web'})
        } catch (e) {
          console.error(e)
          // this.toaster(e.message, 'danger', true)
        }
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    date () {
      return this.item.dateAdded
    },
  }
}
</script>
<style lang="" scoped>
h4 {
  font-size: 20px;
}

span {
  Line-height: 21.33px
}

p {
  font-size: 14px
}

label {
  font-size: 12.64px;
  font-weight: 500
}

td, headerTable {
  height: 20px !important;
}

.input-field {
  border: 2px solid var(--grey-day-030);
	border-radius: 4px;
  height: 48px;
  width: 762px;
}

.input-format-url {
  border: 2px solid var(--grey-day-030);
	border-radius: 4px;
  height: 48px;
  width: 446px;
  background: var(--white)
}

.text-area-field {
  border: 2px solid var(--grey-day-030);
	border-radius: 4px;
  height: 192px

}

.test-area {
  background: var(--grey-day-010);
  width: 308px
}

.textAreaLength {
	font-size: 14.22px;
	color: var(--grey);
	font-weight: 100
}

.format-url {
  background: var(--grey-day-060);
  border-radius: 4px;
  color: var(--white);
  width: 762px;
  height: 128px
}

.sizeBtn {
  font-size: 10px
}

/* tirando a borda do campo de */
.vs__dropdown-toggle {
	border: none !important;
}

.v-picker__title {
  display: none !important
}

.responvive-short-card {
  flex-direction: row;
}

.calendar-card {
  margin-left: 24px;
}

.schedule-card {
    height: 579;
    width: 372px;
  }
  .schedule-teste {
    height: 535px;
    width: 372px;
  }

@media screen and (max-width: 1377px) {
  .responsive-send-card {
    width: 819px
  }
  .schedule-card {
    height: 665px;
    width: 400px;
  }
  .schedule-teste {
    height: 665px;
    width: 400px;
  }
  .responvive-short-card {
    display: flex;
    flex-direction: column;
  }
  .responvive-card {
    display: flex;
    flex-direction: row;
  }
  .calendar-card {
    margin-top: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/DuplicateForm.vue